<template>
  <app-base-main parentTable style="padding: 12px 0 0 0;">
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-warehouse-select
            :fba="false"
            multiple
            v-model="filter.warehouseIds"
            placeholder="全部仓库"
            width="190px"
        >
        </gj-warehouse-select>
        <gj-date-picker
            v-model="filter.date"
            type="month"
            :clearable="false"
        ></gj-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'sku', text: 'SKU'},
              {id: 'name', text: '产品名称'},
          ]"
        >
        </gj-select-input>
        <template #right>
          <gj-tool-group
              log @viewLog="openLog"
              :download="$permission('financialMonthCost:export')"
              download-url="/finance/financialMonthCost/monthCostListExport?type=SELF"
              :download-params="globalParams"
              help
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('financialMonthCost:import')" type="primary" @click="importCost">导入</gj-button>
      <gj-button v-if="$permission('financialMonthCost:batchUpdate')" @click="batchEdit(selectedRows)"
                 :disabled="noSelect">批量修改
      </gj-button>
      <gj-checkbox
          v-model="filterZero">
        <span style="color: #666">过滤期初为0的数据</span>
      </gj-checkbox>
      <span style="font-size:12px;color:#666666;padding-left: 20px">
         <i class="el-icon-info" style="color: #1F6EEF;font-size: 14px"></i>
          成本修改后，需重算后才能对修改月份的数据生效
      </span>
    </template>
    <template #tool-group>
      <div class="tools-tips">
        <div class="tips">
          <span class="gj-icon icon1"></span> <span>未维护</span>
        </div>
        <div class="tips">
          <span class="gj-icon icon2"></span> <span>手动更新</span>
        </div>
        <div class="tips">
          <span class="gj-icon icon3"></span> <span>系统更新</span>
        </div>
      </div>
    </template>
    <template #table>
      <gj-table
          selection
          adaptParent
          ref="gjTable"
          :columns="expandColumns"
          :data="tableData"
          :index="false"
          name="costCenter"
          :bak-selected-rows="bakSelectedRows"
          :bak-rows="selectedRows"
          @clearBakSelectedRows="clearBakRows"
          :scroll-x="{gt: -1}"
          :scroll-y="{gt: -1}"
          :selectable="(row) => !row.$gjExtendRow"
          :child-selection="true"
          :extend-row-config="{prop: 'extendRow'}"
          :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [1, 6]}"
          :default-sort="{ prop: 'sku', order: 'descending'}"
          :checkbox-config="{checkMethod: checkMethod}"
          :pagination="pagination"
          :loading="loading"
          :show-overflow="false"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:imageUrl="{row}">
          <template v-if="row.$gjParentData">
            <div class="flex">
              <div class="flex align-center" style="width: 40px;">
               <gj-image :src="row.imageUrl"></gj-image>
<!--               <gj-tag :color="{ color: '#1F6EEF', bdColor: '#4994FC', bgColor: '#EDF7FF' }" class="img-tag" type="plain" style="margin-left: 3px;">新</gj-tag>-->
              </div>
              <div class="span-sku flex">
                 <div class="flex1"><gj-tooltip :content="row.sku" :text-line="1">SKU：{{ row.sku }}</gj-tooltip></div>
                 <gj-copy-icon :content="row.sku"></gj-copy-icon>
              </div>
              <div class="span-name">
                 <span>{{ row.skuName }}</span>
              </div>
            </div>

          </template>
        </template>
        <template v-slot:warehouseName="{ row }">
          <div class="default" v-if="!row.$gjParentData">
            {{ row.warehouseName | defaultShow }}
          </div>
        </template>
        <template v-slot:purchaseCost="{ row }">
          <template v-if="!row.$gjParentData">
            <template v-if="$permission('financialMonthCost:update')">
              <gj-input
                  v-model="row.purchaseCost"
                  @change="debounceUpdateCost(row,'purchaseCost')"
                  placeholder="采购成本"
                  width="100%"
                  v-number.toFixed4
                  maxlength="13"
              >
                <template #prepend>
                  ￥
                </template>
              </gj-input>
            </template>
            <template v-else>
              {{ row.purchaseCost ? '￥' + row.purchaseCost : '-' }}
            </template>
          </template>
        </template>
        <template v-slot:inventoryCost="{row}">
          <template v-if="$permission('financialMonthCost:update')">
            <gj-input
                v-model="row.inventoryCost"
                @change="debounceUpdateCost(row,'inventoryCost')"
                placeholder="到库成本"
                width="100%"
                maxlength="13"
                v-number.toFixed4
            >
              <template #prepend>
                ￥
              </template>
            </gj-input>
          </template>
          <template v-else>
            {{ row.inventoryCost ? '￥' + row.inventoryCost : '-' }}
          </template>
        </template>
        <template v-slot:lastUpdate="{row}">
          <template v-if="!row.$gjParentData">
            <el-row>
              <el-col :span="19">
                <gj-popover trigger="hover" placement="bottom" width="350px" height="130px">
                  <!-- 悬浮展示的内容 -->
                  <span class="popover-title">近12月更新:</span><br>
                  <div class="popover-hover">
                    <div v-for="(hs,hsIndex) in row['historyStatus2']" :key="hsIndex" class="popover-content">
                      <div v-for="(item,i) in hs" :key="i" class="popover-item">
                        <div v-show="i === 0" class="item-year">{{ item.year }}年</div>
                        <div
                            :class="{'radius-icon':true,'icon1':item.status === 0,'icon2':item.status === 1,'icon3':item.status === 2}"></div>
                        <div>{{ item.month }}</div>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" style='display:flex'>
                    <span
                        :class="{'radius-icon':true,'icon1':item.status === 0,'icon2':item.status === 1,'icon3':item.status === 2}"
                        v-for="(item,i) in row['historyStatus']" :key="i"></span>
                  </div>
                </gj-popover>
              </el-col>
              <el-col :span="5">
                <span class="more" @click="moreHistory(row)">查看更多</span>
              </el-col>
            </el-row>
          </template>
        </template>
        <template v-slot:extend:row="{row}">
          <div class="default">
            <div v-if="!row.expand">
              <gj-link type="default" @click="openDetail(row,true)">
                更多（共{{row.num}}条）
                <i class="iconfont iconzhankai"></i>
              </gj-link>
            </div>
            <div v-else>
              <gj-link type="default" @click="openDetail(row, false)">
                收起
                <i class="iconfont iconshouqi"></i>
              </gj-link>
            </div>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import CostCenterImport from './cost-center-import';
import GjLogModal from "../../../../components/modal/gj-log-modal";
import {queryMixin, selectionMixin} from "../../../../minxins";
import {exportCostCenter, getSelfMonthCostPage, UpdateMonthCost} from "@/api/finance";
import {convertToFullDate} from "@/utils/date.util";
import {isMeaningful, isMeaningless} from "@/utils/common";
import MoreHistory from "@/views/modules/finance/cost-center/more-history";
import costBatchEdit from "@/views/modules/finance/cost-center/cont-batch-edit";

export default {
  name: "cost-center-self",
  mixins: [queryMixin, selectionMixin],
  data() {
    return {
      moduleName: "cost-center-self",
      filter: {
        warehouseIds: null,
        date: new Date(),
        keyword: {
          key: 'sku',
          value: null,
        },
      },
      expandColumns: [
        {id: 'imageUrl', header: '图片', field: 'slot:imageUrl', width: '60px', default: true, disabled: true},
        {id: 'warehouse', header: '仓库名称', field: 'slot:warehouseName', minWidth: '160px', default: true},
        {id: 'purchaseCost', header: '采购成本', field: 'slot:purchaseCost', minWidth: '160px', default: true},
        {id: 'inventoryCost', header: '到库成本', field: 'slot:inventoryCost', minWidth: '160px', default: true},
        {
          id: 'updateUser',
          header: '更新人',
          field: 'updateUserName',
          minWidth: '120px',
          default: true,
          sortable: true,
          sortBy: 'updateUser'
        },
        {id: 'createTime', header: '更新时间', field: 'updateTime', minWidth: '155px', default: true, sortable: true},
        {id: 'lastUpdate', header: '近12月更新', field: 'slot:lastUpdate', minWidth: '320px', default: true},
      ],
      filterZero: false,
      tableData: [],
      debounceUpdateCost: this._.debounce(this.updateCost, 500),
      bakSelectedRows:[],
      notStorage: true
    }
  },
  created() {
    this.sort.prop = 'sku';
  },
  watch: {
    filterZero: {
      handler() {
        this.$gjNoticeQuery();
      },
    },
  },
  methods: {
    checkMethod() {

    },
    $gjQuery() {
      this.selectedRows = [];
      this.clearBakRows();
      this.loading = true;
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
          monthDate: convertToFullDate(this.filter.date, 'yyyy-MM'),
          filter: this.filterZero || false
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      this.globalParams = params;
      getSelfMonthCostPage(params)
          .then((data) => {
            data.records.forEach(child => {
              child.monthCostSelfVOList.forEach(item => {
                item.imageUrl = child.imageUrl;
                item.historyStatus2 = item.historyStatus.reduce((arr, his, i) => {
                  let monthDate = his.monthDate.split('-');
                  his.year = monthDate[0];
                  his.month = monthDate[1];
                  if (i === 0) {
                    arr[0].push(his);
                    return arr;
                  }
                  arr[0][0].year === monthDate[0] ? arr[0].push(his) : arr[1].push(his);
                  return arr;
                }, [[], []])
              })
            })
            this.tableData = data.records.map((v, i) => {
              const items = this._.cloneDeep(v.monthCostSelfVOList);
              let parentKey = Math.floor(Math.random() * (999999 - 100000)) + 100000;
              v.$gjParentKey = parentKey;
              items.forEach(item=>{
                item.$gjChildKey = parentKey;
                item.$gjChildData = true;
                if(!item.purchaseCost && !item.inventoryCost){
                  item.updateTime = null;
                }
              })
              return Object.assign(v, {
                productsCopy: items,
                items: items ? items.slice(0, 3) : [],
                extendRow: items.length > 3,
                expand: false,
                dataIndex: i,
                num: items.length
              })
            });
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
    },
    $gjQueryInitParams() {
      return {
        filter: {
          warehouseIds: null,
          date: new Date(),
          keyword: {
            key: 'sku',
            value: null,
          }
        }
      }
    },
    updateCost(row, key) {
      let value = row[key].split('.')[0]+'';
      if(value.length > 8){
        this.$gjMessage.error('请输入正确的数值,金额不能大于8位，保留4位小数');
        return false;
      }
      const reg = /^[0-9]+(.?[0-9]{1,4})?$/;
      if (isMeaningless(row[key]) || (!isNaN(row[key]) && reg.test(row[key]))) {
        UpdateMonthCost({id: row.id,
          purchaseCost: isMeaningful(row['purchaseCost']) ? row['purchaseCost'] : 0,
          inventoryCost: isMeaningful(row['inventoryCost']) ? row['inventoryCost'] : 0
        })
            .then(() => this.$gjMessage.success('自动保存成功'))
      } else {
        this.$gjMessage.error('请输入正确的数值，保留四位小数');
      }
    },
    importCost() {
      const modal = this.$gjCreate(CostCenterImport, {
        props: {
          type: 'SKU'
        },
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          }
        }
      })
    },
    openLog() {
      this.$gjCreate(GjLogModal, {
        props: {
          url: '/finance/financialMonthCostLog/page',
          params: {
            model: {
              type: 'SELF'
            }
          },
          columns: [
            {id: 'createDate', header: '操作时间', field: 'createTime', width: '120px'},
            {id: 'opUser', header: '操作用户', field: 'opUser', width: '100px'},
            {
              id: 'op',
              header: '操作分类',
              field: 'option:op',
              options: [
                {id: 'Add', text: '新增'},
                {id: 'Update', text: '更新'},
                {id: 'Delete', text: '删除'},
                {id: 'Import', text: '导入'},
                {id: 'Export', text: '导出'},
                {id: 'USER_UPDATE', text: '手动维护'},
                {id: 'SYSTEM_UPDATE', text: '系统维护'}
              ],
              minWidth: '120px'
            },
            {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
          ],
        }
      })
    },
    openDetail(row, flag) {
      if (flag) {
        row.items = row.productsCopy;
        row.expand = flag;
      } else {
        row.items = row.items.slice(0, 3);
        row.expand = flag;
      }
      this.tableData = this.tableData.map(v => {
        if (v.sku === row.sku) {
          v.expand = row.expand;
          v.items = row.items
        }
        return v
      });
      this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
    },
    clearBakRows(){
      this.bakSelectedRows = [];
    },
    batchEdit(rows) {
      let filterRows = rows.filter(v => !v.$gjParentData) || [];
      if(filterRows.length === 0){
        this.$gjMessage.warning("请重新勾选需要提交的数据！")
        return false
      }
      let modal = this.$gjCreate(costBatchEdit, {
        props: {
          type: 'sku',
          rows: filterRows,
        },
        on: {
          updated: () => {
            this.$gjQuery();
            modal.$gjDestroy()
          },
          cancel: () => {
            modal.$gjDestroy()
          }
        },
      });
    },
    moreHistory(row) {
      const modal = this.$gjCreate(MoreHistory, {
        props: {
          formData: row,
          params: {
            keyWord:row.sku,
            type:'sku',
            warehouseId:row.warehouseId
          }
        },
        on: {
          updated: () => {
            this.$gjQuery();
            modal.$gjDestroy()
          },
          cancel() {
            modal.$gjDestroy()
          }
        }
      })
    },
    clickDownload() {
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
          monthDate: convertToFullDate(this.filter.date, 'yyyy-MM'),
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      exportCostCenter(params);
    },
  }
}
</script>

<style scoped lang="scss">
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
.tools-tips {
  margin-right: 14px;
  width: 280px;
  display: flex;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);

  .tips {
    flex: 1;

    .gj-icon {
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 4px;
    }
  }
}

.popover-hover {
  display: flex;
  padding: 4px;

  .popover-content:first-child {
    margin-right: 8px;
  }

  .popover-content {
    display: flex;
    background: rgba(216, 216, 216, 0.2);
    border-radius: 2px;
    padding: 4px;

    .popover-item {
      padding-top: 35px;
      position: relative;

      .item-year {
        position: absolute;
        width: 50px;
        top: 10px;
        left: 0
      }
    }
  }
}

.radius-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 6px;
  margin-right: 5px;
}

.popover-title {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  padding: 5px 0;
}

.icon1 {
  border: 1px solid #CED0D5;
  background-color: #EFF1F3;
}

.icon2 {
  border: 1px solid #EC991A;
  background-color: #FBDDB1;
}

.icon3 {
  border: 1px solid #168FFE;
  background-color: #A7D4FF;

}

.more {
  font-size: 12px;
  color: #1F6EEF;
  margin-left: 5px;
  cursor: pointer;
}

.span-sku {
  width: 200px;
  vertical-align: text-bottom;
  line-height: 45px;
  margin-left: 20px;
  color: #000000;
  font-weight: 500
}

.span-name {
  width: 100%;
  vertical-align: text-bottom;
  line-height: 45px;
  margin-left: 20px;
  color: #333333;
  font-weight: 500
}
/deep/.vxe-body--column .vxe-cell--checkbox {
  //display: block;
  //padding: 0;
  //span {
  //  display: none !important;
  //}
  .custom-checkbox {
    position: absolute;
    left: 0;
    top: 0;
  }
}

/deep/.el-dialog .vxe-cell {
  white-space: pre-line !important;
  word-break: break-all !important;
}
/deep/ .el-popover__reference{
  display: flex!important;
  align-items: center;
}
</style>
